import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('adminToken');
    const adminInfo = localStorage.getItem('adminInfo');
    
    if (!token) {
      setIsAuthenticated(false);
      setLoading(false);
      return;
    }

    try {
      // Check if this is an instructor or admin token
      const userInfo = adminInfo ? JSON.parse(adminInfo) : null;
      const isInstructor = userInfo?.is_instructor;
      
      // Verify token is valid by calling the appropriate endpoint
      const endpoint = isInstructor ? '/instructor/me' : '/admin/me';
      await axios.get(`${API_URL}${endpoint}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Auth check failed:', error);
      // Token is invalid or expired
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminInfo');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-[#1E3A5F] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page, saving the intended destination
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}

// Helper function to get the admin token for API calls
export const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Helper function to get the current admin info
export const getCurrentAdmin = () => {
  const adminInfo = localStorage.getItem('adminInfo');
  return adminInfo ? JSON.parse(adminInfo) : null;
};

// Helper function to logout
export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminInfo');
  window.location.href = '/admin/login';
};
